import * as React from 'react';
import { IconProps } from '../types';

const IcEmpty = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={193}
    height={193}
    viewBox="0 0 193 193"
    fill="none"
    {...props}
  >
      <path
        fill="#F6F7FC"
        d="M28.453 40.816h87.8c3.3 0 6.1 2.7 6.1 6.1v113.9c0 3.3-2.7 6.1-6.1 6.1h-87.8c-3.3 0-6.1-2.7-6.1-6.1v-113.9c0-3.4 2.8-6.1 6.1-6.1Z"
      />
      <path
        fill="#CCD4DC"
        d="M37.753 58.117c1.5-.7 3.1-.5 4.7-.6 18.3.2 36.7 0 55 .1 3.3.1 6.7-.5 9.8.6 1 2.1.6 4.5.7 6.8-.3 9.3.1 18.7-.1 28-.1 3.2-4.1 3.1-6.4 3.2-20-.1-40 0-59.9 0-2.5.2-5.4-1.3-5.2-4.2-.2-9.6 0-19.3-.1-29 .2-1.7-.4-4.1 1.5-4.9ZM36.053 112.916c1.3-1.9 3.1-3.4 5.5-3.2 20-.1 40 0 60-.1 2.3.1 6.3.1 6.4 3.2.4 3-3.3 3.3-5.4 3.3h-61c-2.5.4-4.3-1.3-5.5-3.2Z"
      />
      <path
        fill="#CCD4DC"
        d="M122.253 116.217v-5.5c-.1 6.5-.2 16.9.2 25.3 6.9-.1 13.9.8 20.8-.6.8 14.4-.1 28.9.6 43.4.4 5.8-4.1 11.8-10.3 11.3h-122c-3.3.1-6.6-1-8.7-3.6-1.9-2.8-2.5-6.3-2.3-9.7.9-13.6-.7-27.3 0-40.9h.6c7.1.2 14.2.3 21.2-.1 5.8-.2 12.1-1.3 17.5 1.6 3.2 2.8 2 8 5 11 1.4 1.6 3.8 1.1 5.7 1.3 13.7.3 27.3.1 41 .1 2.6-.2 5.5.1 7.9-1.2 3.2-3 1.6-8.8 5.6-11.3 5-2.8 11.9-1.1 17.3-1.4 0-8.3-.1-10.8-.1-19.7Z"
      />
      <path
        fill="#CCD4DC"
        d="M37.853 126.217c1.4-.9 3.2-.5 4.8-.7 17 .1 34 0 51 .1 4 .1 8-.4 12 .2 2.9.2 3.4 5.6 0 5.4-21 .3-42-.1-63 .2-1.9-.2-4.7.5-5.8-1.7-.6-1.1-.1-2.9 1-3.5Z"
      />
      <path
        fill="#86909C"
        d="M1.153 136.016c6.7-9 13.9-17.7 21.2-26.2.1 8.7-.1 17.4.1 26.2-7.1.3-14.2.2-21.3 0ZM122.253 110.516c7.6 7.6 13.5 17.1 20.9 25-6.9 1.4-14 .5-20.9.6-.1-8.6 0-17.1 0-25.6Z"
      />
      <path
        fill="#CCD4DC"
        d="M186.853 11.617c-7.5-7.4-18.8-9.9-28.9-8.3-11 1.7-22.5 9.6-23.7 21.5-.9 5.9 2.5 11.1 5.1 16-.4 2.6-1.7 4.9-2.2 7.5-.3 1.1 1.3 2.3 2.3 1.6 3.7-.9 7.3-4.2 11.1-2 10.6 4.5 23.3 3.2 32.8-3.2 5.1-3.4 9-8.8 10-14.9 1.2-6.7-1.6-13.7-6.5-18.2Zm-31.2 19.1c-.9 1-2.1 1.6-3.6 1.6-2.6 0-4.8-2.1-4.8-4.8 0-2.7 2.1-4.8 4.8-4.8 2.6 0 4.8 2.1 4.8 4.8 0 1.3-.5 2.3-1.2 3.2Zm8.1 1.6c-2.6 0-4.8-2.1-4.8-4.8 0-2.7 2.1-4.8 4.8-4.8 2.6 0 4.8 2.1 4.8 4.8 0 2.7-2.2 4.8-4.8 4.8Zm11.8 0c-2.6 0-4.8-2.1-4.8-4.8 0-2.7 2.1-4.8 4.8-4.8 2.6 0 4.8 2.1 4.8 4.8 0 2.7-2.2 4.8-4.8 4.8Z"
      />
  </svg>
);

export default IcEmpty;
